<template>
  <v-col
    :cols="cols"
    :sm="sm"
    :md="md"
    :lg="lg">
    <v-menu
      v-model="menu"
      :close-on-content-click="false"
      :nudge-right="40"
      transition="scale-transition"
      offset-y
      min-width="290px">
      <template v-slot:activator="{ on }">
        <v-text-field
          v-on="on"
          v-model="dateFormatted"
          filled
          v-bind="$attrs"
          :rounded="!hasError"
          :outlined="hasError"
          height="60"
          readonly
          hide-details
          class="my-input custom-label-color"
          color="#6A83B5"
          background-color="#F2F6FF">
          <template v-slot:label>
            <strong :class="hasError ? '' : 'custom-input-label-color'">
              {{ $attrs.label }}
            </strong>
          </template>
          <template v-slot:prepend-inner>
            <v-icon :class="iconColor">
              mdi-calendar-today
            </v-icon>
          </template>
        </v-text-field>
      </template>
      <v-date-picker
        v-model="date"
        locale="es-mx"
        no-title
        v-bind="$attrs"
        @input="menu = false">
      </v-date-picker>
    </v-menu>
  </v-col>
</template>

<script>
export default {
  name: 'DatePickerCustom',
  props: {
    value: {
      type: String,
      required: false,
      default() {
        return this.value;
      },
    },
    cols: {
      type: String,
      default: '12',
    },
    sm: {
      type: String,
      default() {
        return this.sm || this.cols;
      },
    },
    md: {
      type: String,
      default() {
        return this.md || this.sm;
      },
    },
    lg: {
      type: String,
      default() {
        return this.lg || this.md;
      },
    },
  },
  data() {
    return {
      menu: false,
      hasError: false,
      greyIcon: 'base6--text',
      redIcon: 'red--text',
    };
  },
  // mounted() {
  //   if (this.value === null) {
  //     this.value = new Date().toISOString().substr(0, 10);
  //   }
  // },
  computed: {
    iconColor() {
      return this.hasError ? this.redIcon : this.greyIcon;
    },
    dateFormatted: {
      get() {
        if (!this.date) return null;
        const [year, month, day] = this.date.split('-');
        return `${day}-${month}-${year}`;
      },
      set() {},
    },
    date: {
      get() {
        // if (this.value === null) {
        //   return new Date().toISOString().substr(0, 10);
        // }
        return this.value;
      },
      set(val) {
        this.$emit('input', val);
      },
    },
  },
};
</script>

<style lang="scss">
</style>
